import React, { useState, useEffect } from "react"
import { useParams } from "react-router-dom"
import axios from "axios"
import Grid from "@material-ui/core/Grid"
import Alert from "@material-ui/lab/Alert"

import HotelRequestDetails from "../common/hotel/hotel-request-details"
import HotelRequestChips from "../common/hotel/hotel-request-chips"
import HotelOfferForm from "../common/hotel/hotel-offer-form"
import HotelAppliedOffers from "../common/hotel/hotel-applied-offers"
import RequestDetailsSkeleton from "../common/skeleton/request-details-skeleton"
import RequestInfoSkeleton from "../common/skeleton/request-info-skeleton"
import RequestOfferSkeleton from "../common/skeleton/request-offer-skeleton"
import RequestInfo from "../common/request/request-info"
import RequestPreview from "../common/request/request-preview"
import { Panel, PanelHeader, PanelContent } from "../common/panel"
import { checkTokenExpirationMiddleware } from "../../../middlewares/users-auth.middleware"

const HotelRequest = () => {
  let { id } = useParams()
  const [reservationRequest, setReservationRequest] = useState(null)
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)
  const [reloadOffers, setReloadOffers] = useState(null)
  const [user] = useState(checkTokenExpirationMiddleware())
  useEffect(() => {
    setLoading(true)
    setError(null)

    axios
      .get(`${process.env.REACT_APP_API}/api/requests/${id}?q=hotel`, {
        headers: {
          Authorization: `Bearer ${user.Token}`
        }
      })
      .then(res => {
        setReservationRequest(res.data)
        setTimeout(() => setLoading(false), 750)
      })
      .catch(() => {
        setReservationRequest(null)
        setError("Unable to load request details. Please check your connection or contact support if this issue persists.")
        setLoading(false)
      })
  }, [id, user.Token])

  const handleReloadOffers = () => {
    let reload = { ...reloadOffers }
    setReloadOffers(reload)
  }

  return (
    <Grid container spacing={3}>
      <Grid container item xs={12} md={12} lg={9}>
        <Panel>
          <PanelHeader>Request Details</PanelHeader>
          <PanelContent>{loading ? <RequestDetailsSkeleton /> : error ? <Alert onClose={() => setError(null)} severity="error">{error}</Alert> : reservationRequest ? <RequestPreview label={"Hotel"} keyword={"Hotels"} reservationRequest={reservationRequest} Details={<HotelRequestDetails hotelResources={reservationRequest.reservationRequestHotelResources} />} Chips={<HotelRequestChips variant={"default"} customClasses={"contain-info"} hotelResources={reservationRequest.reservationRequestHotelResources} />} /> : null}</PanelContent>
        </Panel>

        <Panel>
          <PanelHeader>My Offers</PanelHeader>
          <PanelContent>{reservationRequest ? <HotelAppliedOffers reloadOffers={reloadOffers} reservationReqId={reservationRequest.id} /> : null}</PanelContent>
        </Panel>

        <Panel>
          <PanelHeader>Add An Offer</PanelHeader>
          <PanelContent>{loading ? <RequestOfferSkeleton /> : reservationRequest ? <HotelOfferForm handleReloadOffers={handleReloadOffers} reservationReqId={reservationRequest.id} hotelResources={reservationRequest.reservationRequestHotelResources} /> : null}</PanelContent>
        </Panel>
      </Grid>

      <Grid container item xs={12} md={12} lg={3}>
        <div className="side-info">{loading ? <RequestInfoSkeleton /> : reservationRequest ? <RequestInfo reservationRequest={reservationRequest} /> : null}</div>
      </Grid>
    </Grid>
  )
}

export default HotelRequest
